<script>
export default {
  name: "SubscriptionMixin",
  props: [
  ],
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
    getSubscriptionName: function (name) {
      if (name == 'StandardMonthly')
        return 'Monthly Subscription';
      else if (name == 'StandardYearly')
        return 'Yearly Subscription';

      return null;
    },
    getPriceDuration: function (name) {
      if (name == 'StandardMonthly')
        return '/month';
      else if (name == 'StandardYearly')
        return '/year';

      return null;
    },
    getSubscriptionPrice: function (name) {
      if (name == 'StandardMonthly')
        return 39.80;
      else if (name == 'StandardYearly')
        return 398.00;

      return null;
    },
  },
  mounted () {
  }
};
</script>